var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Functions.define_worker_handler = function (in_implements, options) {
    var implements = [Options, Events];
    /* istanbul ignore if */
    if (in_implements && in_implements.length) {
        implements = implements.combine(in_implements);
    }
    /* istanbul ignore next */
    if (options) {
        if (options.service_worker && OCS.Functions.is_service_workers_supported()) {
            implements.combine([new Class(OCS.Interfaces.ServiceWorkerHandler)]);
        }
        if (options.shared_worker && OCS.Functions.is_shared_workers_supported()) {
            implements.combine([new Class(OCS.Interfaces.SharedWorkerHandler)]);
        }
        if (options.workers && OCS.Functions.is_workers_supported()) {
            implements.combine([new Class(OCS.Interfaces.WorkerHandler)]);
        }
    } else if (OCS.Functions.is_workers_supported()) {
        implements.combine([new Class(OCS.Interfaces.WorkerHandler)]);
    }

    return new Class({
        Implements: implements,
        class_type: "WorkerHandler",
        class_name: "WorkerHandler",
        worker_id: null,
        is_idle: false,
        status: "unknown",
        online_status: false,
        active_request: null,
        onmessage: null,
        msg_queue: [],
        msg_queue_timeout: null,
        idle_termination_timeout: null,
        options: {
            events: {
                terminating_worker: "terminating_worker",
                worker_status_update: "worker_status",
                worker_available: "worker_available",
                worker_finished: "worker_finished",
                worker_idle: "worker_idle",
                worker_msg_recieved: "worker_msg_recieved",
                worker_online: "worker_online",
                worker_offline: "worker_offline",
                worker_terminated: "worker_terminated"
            },
            idle_text: 'idle',
            init_text: 'init',
            unknown_status_text: 'unknown',
            active_text: 'active',
            debug: false,
            path: "",
            max_msg_queue_retries: 3,
            time_stop_to_destroy: 500,
            time_to_msg_queue: 10,
            time_to_msg_queue_fail_increment: 10
        },
        time_to_msg_queue: 10,
        bound_methods: {},
        initialize: function (ops) {
            if (!ops || !ops.path) {
                console.error("WorkerHandler: No path defined!");
                return;
            }
            if (ops.id) {
                this.worker_id = ops.id;
                delete ops.id;
            }
            this.bound_methods.destroy = this.destroy.bind(this);
            this.setOptions(ops);
            /* istanbul ignore else */
            this.init();
            if (this.on_worker_finished) {
                this.addEvent(this.options.events.worker_finished, this.on_worker_finished.bind(this));
            }
        },
        /**
         * init - Start the shared worker and apply a message hanlder to it
         */
        init: function () {
            if (this.worker === null && this.options.path && this.on_init_timeout) {
                this.worker = setTimeout(this.on_init_timeout.bind(this), 10);
                return true;
            }
            console.warn("Worker: Unable to start worker");
            if (this.worker) {
                console.warn("Worker: A worker has already been started.");
            }
            if (!this.options.path) {
                console.warn("Worker: No path was defined.");
            }
            if (!this.on_init_timeout) {
                console.warn("Worker: This browser does not support workers.");
            }
            return false;

        },
        // Actions
        /**
         * add_to_msg_queue - Add a message to be sent to the worker
         * @param {Object} msg - Message object in the form {cmd: "", options: {}};
         * @param {String} msg.cmd - Command for the worker to perform.
         * @param {String|Number|Object} msg.options - Options to be used by the command being passed to the worker
         */
        add_to_msg_queue: function (msg) {
            if ((!this.online_status || this.msg_queue.length || !this.send_worker_message) && (!this.online_status || msg.cmd !== "status" || !this.send_worker_message || !isNaN(this.worker))) {
                this.msg_queue.push(msg);
                if (!this.msg_queue_timeout) {
                    this.msg_queue_timeout = setTimeout(this.send_from_msg_queue.bind(this), this.time_to_msg_queue);
                }
            } else {
                if (this.send_worker_message) {
                    this.send_worker_message(msg);
                }
            }
        },
        clear_active_request: function () {
            this.active_request = null;
        },
        /**
         * send_from_msg_queue - Send messages from the queue to the worker
         */
        send_from_msg_queue: function () {
            if (this.msg_queue_timeout) {
                clearTimeout(this.msg_queue_timeout);
                this.msg_queue_timeout = null;
            }
            if (this.msg_queue.length) {
                if (this.online_status && this.send_worker_message && isNaN(this.worker)) {
                    var msg = this.msg_queue.shift();
                    if (this.send_worker_message(msg)) {
                        // With a success lets reset time to msg queue value to the default value
                        this.time_to_msg_queue = this.options.time_to_msg_queue;
                    } else {
                        // Spread out the attempts on this for each fail
                        this.time_to_msg_queue = this.time_to_msg_queue + this.options.time_to_msg_queue_fail_increment;
                        if (!msg.retries || msg.retries < this.options.max_msg_queue_retries) {
                            this.add_to_msg_queue(msg);
                        }
                    }
                } else {
                    // Spread out the attempts on this for each fail
                    this.time_to_msg_queue = this.time_to_msg_queue + this.options.time_to_msg_queue_fail_increment;
                }
                if (this.msg_queue.length) {
                    this.msg_queue_timeout = setTimeout(this.send_from_msg_queue.bind(this), this.time_to_msg_queue);
                }
            }
        },
        // Set / Get methods
        set_active_request: function (req) {
            if (this.active_request === null) {
                if (req.init_msg && req.init_msg.options) {
                    this.add_to_msg_queue(req.init_msg);
                }
                if (req.msg) {
                    this.add_to_msg_queue(req.msg);
                }
                if (req.msg_queue) {
                    this.msg_queue.combine(req.msg_queue);
                }
                this.active_request = req;

                return true;
            }
            return false;
        },
        set_onmessage: function (method) {
            this.onmessage = method;
        },
        set_status: function (status) {
            this.status = status;
            if (this.status === this.options.idle_text) {
                this.is_idle = true;
            } else {
                this.is_idle = false;
            }
        },
        /**
         * Remove the worker from the handler
         */
        clear_worker: function () {
            if (this.worker) {
                if (isNaN(this.worker)) {
                    try {
                        this.stop_worker();
                    } catch (e) {
                        console.warn("Worker Handler: Unable to terminate worker.", e);
                    }
                } else {
                    clearTimeout(this.worker);
                }
            }
            this.worker = null;
        },
        /**
         * set_worker - Set the worker to be used by the handler
         * @param {type} worker - 
         */
        set_worker: function (worker) {
            this.clear_worker();
            this.worker = worker;
        },
        destroy: function () {
            if (this.msg_queue_timeout) {
                clearTimeout(this.msg_queue_timeout);
                this.msg_queue_timeout = null;
            }
            this.fireEvent(this.options.events.terminating_worker, this);
            /* istanbul ignore next */
            setTimeout(function () {
                // This ensures anything else listening on the terminating event gets fired as well
                this.removeEvents();
                this.$events = {};
            }.bind(this), 0);
            this.clear_worker();
        }
    });
};
OCS.Classes.WorkerHandler = OCS.Functions.define_worker_handler();
OCS.Classes.SharedWorkerHandler = OCS.Functions.define_worker_handler(null, {shared_worker: true});
OCS.Classes.ServiceWorkerHandler = OCS.Functions.define_worker_handler(null, {service_worker: true});